import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { compose } from 'recompose';

import { withCoachTaskAdminContextProvider } from '../../context/CoachTaskAdminContext';
import CoachTaskAdminDashboard from '../../pages/CoachTaskAdmin/CoachTaskAdminDashboard';
import CoachTaskAdminDetail from '../../pages/CoachTaskAdmin/CoachTaskAdminDetail';

const CoachTaskAdminRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/:coachId`} component={CoachTaskAdminDetail} />
      <Route exact path={path} component={CoachTaskAdminDashboard} />
    </Switch>
  );
};

export default compose(
  withCoachTaskAdminContextProvider,
)(CoachTaskAdminRoutes);
